/**************************************************
 * Nombre:       Home_Porcentajes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import ganancias from '../../../Recursos/ganancias.png'
import Tarjeta_ProcentajeTitulo from "../../Tarjetas/Tarjeta_ProcentajeTitulo";
import {ArrowForward} from "@mui/icons-material";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Informacion from "../../Dialogos/Dialogo_Informacion";

const Home_Porcentajes = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Informacion, titulo: 'Dejanos Contactarte'})


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <img src={ganancias} alt="Ganancias" width={'100%'} height={'auto'} style={{borderRadius: 30}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'center', mt: sCell ? 6 : 0}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 5}}
                        spacing={4}
                    >

                        {items.map((item, index) => (
                            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_ProcentajeTitulo item={item}/>
                            </Grid>
                        ))}

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <Button
                            onClick={abrir}
                            >
                                <Typography sx={{fontWeight: 500, pl: 3, pr: 2, color: '#fff'}}>Mas
                                    información</Typography>
                                <span><IconButton
                                    sx={{backgroundColor: '#fff'}}><ArrowForward
                                    sx={{width: 16, height: 16, fill: '#010101'}}/></IconButton></span> </Button>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Porcentajes

const items = [
    {
        nombre: 'Trimestral',
        porcentaje: 3
    },
    {
        nombre: 'Semestral',
        porcentaje: 6
    },
    {
        nombre: 'Anual',
        porcentaje: 12
    },
    {
        nombre: 'Tu Dinero',
        porcentaje: 100
    },
]